import { CapoPlugin } from "/codefresh/volume/ybd/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];